import React from 'react';
import 'twin.macro';

import Heading from '~components/Heading';
import Text, { Bold, ConstrainedText } from '~components/Text';

const ResearchGrants: React.FC = () => (
  <>
    <ConstrainedText>
    Grâce au soutien de nos généreux donateurs, FRDJ est le principal bailleur de fonds caritatif de la recherche sur le diabète de type 1 (DT1) au Canada. Nous travaillons également conjointement avec nos filiales mondiales pour soutenir des projets dans le monde entier. 
    </ConstrainedText>
    <Bold>
    La pandémie aurait pu avoir un impact sur le rythme du changement, mais, grâce à votre engagement et au dévouement de nos chercheurs, nous avons tout de même pu accélérer ce travail crucial.
    </Bold>
    <ConstrainedText>
    FRDJ Canada prévoit que les fonds destinés à la recherche sur le DT1 en 2021 atteindront les niveaux d’avant la pandémie. Nous avons également l’intention d’augmenter considérablement le montant du financement de la recherche sur le DT1 par an en 2022 et au-delà et d’au moins doubler chaque année notre financement de la recherche pour 2019 d’ici 2023. Avec ce financement, nous continuerons à soutenir la recherche préclinique et clinique transformationnelle sur le DT1 à travers les subventions conventionnelles qui nous aident à faire progresser notre stratégie de recherche mondiale à quatre piliers, à élargir le portefeuille de subventions financées en partenariat avec les IRSC et d’autres organismes de financement, et également à lancer une sélection d’initiatives spéciales, y compris un Centre d’excellence FRDJ à l’université de Colombie-Britannique axé sur la recherche d’une guérison pour le DT1 (date de lancement fin 2021).
    </ConstrainedText>
    <Heading level="h2" tw="text-blue-800">
    Subventions de recherches actives de FDRJ au Canada en 2019 et 2020
    </Heading>
    <div tw="grid gap-12 mb-32 lg:(grid-cols-2)">
      <div>
        <Heading level="h3" tw="text-blue-800">
          2019
        </Heading>
        <div tw="flex flex-col space-y-6">
          <div>
            <Text tw="font-bold mb-3">Nouvelles subventions - 8</Text>
            <div tw="h-16 w-3/12 bg-blue-300" />
          </div>
          <div>
            <Text tw="font-bold mb-3">Essais cliniques - 12</Text>
            <div tw="h-16 w-5/12 bg-blue" />
          </div>
          <div>
            <Text tw="font-bold mb-3">Bourses de formation - 11</Text>
            <div tw="h-16 w-4/12 bg-blue-700" />
          </div>
          <div>
            <Text tw="font-bold mb-3">Toutes les subventions - 38</Text>
            <div tw="h-16 w-11/12 bg-blue-900" />
          </div>
        </div>
      </div>
      <div>
        <Heading level="h3" tw="text-blue-800">
          2020
        </Heading>
        <div tw="flex flex-col space-y-6">
          <div>
            <Text tw="font-bold mb-3">Nouvelles subventions - 3</Text>
            <div tw="h-16 w-1/12 bg-blue-300" />
          </div>
          <div>
            <Text tw="font-bold mb-3">Essais cliniques - 10</Text>
            <div tw="h-16 w-3/12 bg-blue" />
          </div>
          <div>
            <Text tw="font-bold mb-3">Bourses de formation  - 11</Text>
            <div tw="h-16 w-4/12 bg-blue-700" />
          </div>
          <div>
            <Text tw="font-bold mb-3">Toutes les subventions - 27</Text>
            <div tw="h-16 w-10/12 bg-blue-900" />
          </div>
        </div>
      </div>
    </div>
  </>
);

export default ResearchGrants;
